/**
 * Hub Medical
 * Hub medical Consorcio
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Opção de upgrade disponível para um plano de acesso
 */
export interface UpgradeOptionDTO { 
    /**
     * ID do pacote de produto
     */
    packageId?: number;
    /**
     * Nome do plano de upgrade
     */
    name?: string;
    /**
     * Descrição do plano de upgrade
     */
    description?: string;
    /**
     * Tipo do pacote
     */
    packageType?: UpgradeOptionDTO.PackageTypeEnum;
    /**
     * Valor mensal do plano atual
     */
    currentPlanValue?: number;
    /**
     * Valor mensal do plano de upgrade
     */
    upgradePlanValue?: number;
    /**
     * Diferença de valor (upgrade - atual)
     */
    valueDifference?: number;
    /**
     * Benefícios adicionais do plano de upgrade
     */
    additionalBenefits?: Array<string>;
    /**
     * Aumento de capacidade (profissionais/conexões)
     */
    capacityIncrease?: number;
}
export namespace UpgradeOptionDTO {
    export type PackageTypeEnum = 'SUBSCRIPTION_PROVIDER_PF_FREE' | 'SUBSCRIPTION_PROVIDER_PF_BASIC' | 'SUBSCRIPTION_LAB_FREE' | 'SUBSCRIPTION_LAB_BASIC' | 'SUBSCRIPTION_PROVIDER_PJ_FREE' | 'SUBSCRIPTION_PROVIDER_PJ_2' | 'SUBSCRIPTION_PROVIDER_PJ_6' | 'SUBSCRIPTION_PROVIDER_PJ_10' | 'SUBSCRIPTION_PROVIDER_PJ_PERSONAL' | 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_FREE' | 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_100' | 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_PERSONAL' | 'SUBSCRIPTION_CONTRACTOR_PJ_120' | 'SUBSCRIPTION_CONTRACTOR_PJ_PERSONAL' | 'SUBSCRIPTION_ADMINISTRATOR';
    export const PackageTypeEnum = {
        ProviderPfFree: 'SUBSCRIPTION_PROVIDER_PF_FREE' as PackageTypeEnum,
        ProviderPfBasic: 'SUBSCRIPTION_PROVIDER_PF_BASIC' as PackageTypeEnum,
        LabFree: 'SUBSCRIPTION_LAB_FREE' as PackageTypeEnum,
        LabBasic: 'SUBSCRIPTION_LAB_BASIC' as PackageTypeEnum,
        ProviderPjFree: 'SUBSCRIPTION_PROVIDER_PJ_FREE' as PackageTypeEnum,
        ProviderPj2: 'SUBSCRIPTION_PROVIDER_PJ_2' as PackageTypeEnum,
        ProviderPj6: 'SUBSCRIPTION_PROVIDER_PJ_6' as PackageTypeEnum,
        ProviderPj10: 'SUBSCRIPTION_PROVIDER_PJ_10' as PackageTypeEnum,
        ProviderPjPersonal: 'SUBSCRIPTION_PROVIDER_PJ_PERSONAL' as PackageTypeEnum,
        ProviderContractorPjFree: 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_FREE' as PackageTypeEnum,
        ProviderContractorPj100: 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_100' as PackageTypeEnum,
        ProviderContractorPjPersonal: 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_PERSONAL' as PackageTypeEnum,
        ContractorPj120: 'SUBSCRIPTION_CONTRACTOR_PJ_120' as PackageTypeEnum,
        ContractorPjPersonal: 'SUBSCRIPTION_CONTRACTOR_PJ_PERSONAL' as PackageTypeEnum,
        Administrator: 'SUBSCRIPTION_ADMINISTRATOR' as PackageTypeEnum
    };
}


